import { LogOut } from 'lucide-react'
import { supabase } from '@/lib/supabase'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface LogoutDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  hasUnsavedChanges?: boolean
}

export function LogoutDialog({ open, onOpenChange, hasUnsavedChanges = false }: LogoutDialogProps) {
  const handleLogout = () => {
    // 1. Remove auth token do localStorage imediatamente (síncrono)
    try { localStorage.removeItem('painel-barbara-auth') } catch { /* ignore */ }

    // 2. Fire-and-forget: notifica Supabase (não espera resposta)
    supabase.auth.signOut({ scope: 'local' }).catch(() => {})

    // 3. Hard redirect imediato - recarrega o app do zero sem sessão
    window.location.href = '/login'
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <LogOut className="h-5 w-5 text-primary" />
            Confirmar Saída
          </DialogTitle>
          <DialogDescription>
            {hasUnsavedChanges ? (
              <>
                Você tem <strong>alterações não salvas</strong>. Tem certeza de que deseja sair?
                Todas as alterações serão perdidas.
              </>
            ) : (
              'Tem certeza de que deseja sair do sistema?'
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={handleLogout}>
            Sair
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
